import { EventAggregator } from "aurelia-event-aggregator";
import { autoinject, computedFrom, transient } from "aurelia-framework";
import { BindingSignaler } from "aurelia-templating-resources";
import { ValidationController } from "aurelia-validation";
import { Operation } from "../../../../../../client-validation-system/base-validations/compare-validation";
import { ClientSideValidator, EntityValidationsService } from "../../../../../../client-validation-system/validations-service";
import { RulesHolder, ValidationActivation, ValidationTypeEnum } from "../../../../../../client-validation-system/validations.models";
import { VetRuleOutcomeStepEnum } from "../../../../../../models/vetting/vetting.models";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { SignalClientService } from "@rightship-tech/common-ui/services/basic/signal-client.service";
import { LookupClientService } from "../../../../../../services/lookups/lookup-client.service";
import { CustomerService } from "../../../../../../services/modules/customer-client.service";
import { VettingService } from "../../../../../../services/vetting/vetting.service";
import { Reflection } from "../../../../../../utilities/reflection";
import { VetStatusDialog } from "../vet-status-dialog/vet-status-dialog";

@transient()
@autoinject
export class ApplyForWaiverDialog extends VetStatusDialog {
    acceptTerms: boolean = false;
    validator: ClientSideValidator;
    constructor(lookupClientService: LookupClientService, dialogClientService: DialogClientService, notificationsClientService: NotificationClientService,
        vetClientService: VettingService, validationController: ValidationController, customerService: CustomerService,
        userClaimsService: UserClaimsService, private entityValidationsService:EntityValidationsService, signalClientService: SignalClientService,
        eventAggregator:EventAggregator, signal:BindingSignaler) {
        super(lookupClientService, dialogClientService, notificationsClientService,
            vetClientService, validationController, customerService,
            userClaimsService, signalClientService, eventAggregator, signal);
    }

    async activate(model) {
        await super.activate(model);
        this.currentVetStatus = this.allVetStatuses.filter(x => x.id == this.escalated)[0];
        this.draftGenerated = true;
    }

    @computedFrom(Reflection.getPropertyPath<ApplyForWaiverDialog>(z => z.tasks),
    Reflection.getPropertyPath<ApplyForWaiverDialog>(z => z.tasks.length))
    get canBeWaived() {
        return this.tasks ? this.tasks.filter(x => x.outcomeId == VetRuleOutcomeStepEnum.Fail).map(x => x.name) : []
    }

    @computedFrom(Reflection.getPropertyPath<ApplyForWaiverDialog>(z => z.canBeWaived),
    Reflection.getPropertyPath<ApplyForWaiverDialog>(z => z.canBeWaived.length),
    Reflection.getPropertyPath<ApplyForWaiverDialog>(z => z.failed))
    get submitEnabled(): boolean {
        return this.canBeWaived.length > 0 && this.canBeWaived.length == this.failed;
    }

    attached(){
        const rulesHolder: RulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "Apply for Waiver",
            isCollection: false,
            nestedRulesHolder: [],
            rules: [{
                errorMessage: "Reason for Waiver is required",
                parameters: null, property:  Reflection.getPropertyName<ApplyForWaiverDialog>(x => x.comments),
                validationType: ValidationTypeEnum.Required
            }, {
                errorMessage: "You need to accept overriding this decision",
                parameters: JSON.stringify({
                    property: Reflection.getPropertyName<ApplyForWaiverDialog>(x => x.acceptTerms),
                    operation: Operation.Equal,
                    value: true
                }), property: Reflection.getPropertyName<ApplyForWaiverDialog>(x => x.acceptTerms),
                validationType: ValidationTypeEnum.Compare
            }]
        };
        this.validator = this.entityValidationsService.getValidator(this, rulesHolder);
    }

    async submit() {

        const validationResponse = await this.validator.validate();

        if (!validationResponse.valid) return;

        try {
            await this.vetClientService.applyForWaiver(this.vetId,  this.comments);
            if (this.onSubmit) {
                this.onSubmit(true);
            }
            this.dialogClientService.hide();
        } catch (e) {
            console.error("Failed to apply for Waiver", e);
        }
    }

    cancel(){
        this.dialogClientService.hide();
    }
}
